<template>
  <WizardStep name="personal">
    <FieldGroup
      title="Bitte teile uns Deine Kontaktdaten mit:"
      subtitle="Alle Felder, die mit * markiert sind, sind Pflichtfelder."
    >
      <div class="row">
        <div class="col-md-6">
          <SelectField
            name="gender"
            placeholder="Geschlecht"
            :options="formContext.getOptionSet('genders')"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <TextField name="firstname" placeholder="Vorname" />
        </div>
        <div class="col-md-6">
          <TextField name="lastname" placeholder="Nachname" />
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <EmailField />
        </div>
        <div class="col-md-6">
          <PhoneField />
        </div>
      </div>
    </FieldGroup>
    <Panel
      slot="footer"
      title="Ich habe keine E-Mail-Adresse, kann ich mich trotzdem bewerben?"
    >
      Nein. Wenn Du Dich bei uns bewirbst, benötigst Du eine gültige
      E-Mail-Adresse sowie Telefonnummer, damit wir Dich zu Deiner Bewerbung
      erreichen können.
    </Panel>
  </WizardStep>
</template>

<script>
import formContextAware from '../mixin/formContextAware';

export default {
  mixins: [formContextAware],
};
</script>
